import { motion } from "framer-motion";
import { CalendarBlank, Sun, Calendar, CalendarCheck, Check } from "@phosphor-icons/react";

const plans = [
  {
    icon: Sun,
    period: "Günlük",
    desc: "Kısa süreli konaklamalar için ideal",
    features: ["Full eşyalı daire", "Tüm faturalar dahil", "Kahvaltı dahil", "Temizlik hizmeti", "İnternet dahil"],
    accent: false,
  },
  {
    icon: CalendarBlank,
    period: "Haftalık",
    desc: "Bir haftalık konforlu konaklama",
    features: ["Full eşyalı daire", "Tüm faturalar dahil", "Kahvaltı dahil", "Temizlik hizmeti", "İnternet dahil", "Otopark"],
    accent: true,
  },
  {
    icon: Calendar,
    period: "Aylık",
    desc: "Uzun süreli konaklama avantajları",
    features: ["Full eşyalı daire", "Tüm faturalar dahil", "Kahvaltı dahil", "Temizlik hizmeti", "İnternet dahil", "Otopark", "Mangal alanı"],
    accent: false,
  },
  {
    icon: CalendarCheck,
    period: "Yıllık",
    desc: "En avantajlı uzun dönem konaklama",
    features: ["Full eşyalı daire", "Tüm faturalar dahil", "Kahvaltı dahil", "Temizlik hizmeti", "İnternet dahil", "Otopark", "Mangal alanı", "Komisyonsuz"],
    accent: false,
  },
];

const AccommodationPlans = () => {
  return (
    <section
      id="konaklama"
      data-testid="accommodation-section"
      className="section-padding bg-[#F9F6F0]"
    >
      <div className="container-main">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="overline mb-4 inline-block">Konaklama Seçenekleri</span>
          <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#1A1A1A] mb-4">
            Size Uygun <span className="text-[#4A5D23]">Plan</span>
          </h2>
          <p className="font-['Outfit'] text-base sm:text-lg text-[#4A4A4A] max-w-2xl mx-auto">
            Günlük, haftalık, aylık veya yıllık konaklama seçenekleriyle ihtiyacınıza en uygun planı belirleyin.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {plans.map((plan, i) => (
            <motion.div
              key={plan.period}
              data-testid={`plan-card-${plan.period.toLowerCase()}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.5 }}
              className={`rounded-2xl p-8 sm:p-10 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl relative overflow-hidden ${
                plan.accent
                  ? "bg-[#4A5D23] text-white"
                  : "card-surface"
              }`}
            >
              {plan.accent && (
                <div className="absolute top-4 right-4 bg-[#C46235] text-white text-[10px] font-['Outfit'] font-bold tracking-wider uppercase px-3 py-1 rounded-full">
                  Popüler
                </div>
              )}
              <plan.icon
                size={40}
                weight="duotone"
                className={`mb-6 ${plan.accent ? "text-white/80" : "text-[#4A5D23]"}`}
              />
              <h3 className={`font-['Playfair_Display'] text-2xl font-bold mb-2 ${plan.accent ? "text-white" : "text-[#1A1A1A]"}`}>
                {plan.period}
              </h3>
              <p className={`font-['Outfit'] text-sm mb-6 ${plan.accent ? "text-white/70" : "text-[#4A4A4A]"}`}>
                {plan.desc}
              </p>
              <ul className="space-y-3">
                {plan.features.map((f) => (
                  <li key={f} className="flex items-start gap-2.5">
                    <Check
                      size={18}
                      weight="bold"
                      className={`flex-shrink-0 mt-0.5 ${plan.accent ? "text-[#C46235]" : "text-[#4A5D23]"}`}
                    />
                    <span className={`font-['Outfit'] text-sm ${plan.accent ? "text-white/90" : "text-[#4A4A4A]"}`}>
                      {f}
                    </span>
                  </li>
                ))}
              </ul>
              <button
                data-testid={`plan-cta-${plan.period.toLowerCase()}`}
                onClick={() => document.querySelector("#iletisim")?.scrollIntoView({ behavior: "smooth" })}
                className={`mt-8 w-full py-3.5 rounded-full font-['Outfit'] font-semibold text-sm transition-all duration-300 ${
                  plan.accent
                    ? "bg-white text-[#4A5D23] hover:bg-white/90 hover:shadow-lg"
                    : "bg-[#4A5D23] text-white hover:bg-[#3B4A1C] hover:shadow-lg hover:shadow-[#4A5D23]/15"
                }`}
              >
                Bilgi Alın
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AccommodationPlans;
